import styled from "styled-components";

export const Thead = styled.thead`
    background-color: rgba(195, 35, 64, 0.3);
    line-height: 2.5;
`;
